import { APIClient } from "@velzon/utils/axios/api_helper.js";

const AxiosClient = new APIClient()
const dashboardFetch = () => AxiosClient.get(`/dashboard/view`)

export {
  dashboardFetch
}